import React, { Component, useState, useEffect } from "react";
import { Container, Row, Button, Col, Label, FormGroup } from "reactstrap";
import SiteConversationModal from "../SiteConversationModal";
import "./index.css";
import ApiCaller from "../../api/apiCaller";
import t from "utils/Lang";

interface SiteConversationProps {
  siteId: number;
}

export default function SiteConversationView({
  siteId,
}: SiteConversationProps) {
  const [isShowModal, setIsShowModal] = useState(false);
  const [conversations, setConversations] = useState<Array<any>>([]);
  const getConversations = async () => {
    const res = await ApiCaller.get(`site_conversation/list?site_id=${siteId}`);
    if (res?.status === "ok") {
      setConversations(res?.result);
    }
  };
  useEffect(() => {
    getConversations();
  }, []);
  return (
    <div>
      <Row>
        <Col sm={{ size: 4, offset: 0 }}>
          <Label>{t().store_detail__update}</Label>
        </Col>
        <Col sm={{ size: 8, offset: 0 }}>
          <Button
            color="success"
            onClick={() => {
              setIsShowModal(true);
            }}
          >
            {t().action__add_update}
          </Button>
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        {conversations.map((conversation, index) => {
          let title = conversation?.user_name || conversation.created_by;
          if (conversation?.contact_date) {
            title = title + ` | ${conversation?.contact_date}`;
          }
          if (conversation?.contact_channel) {
            title = title + ` | ${conversation?.contact_channel}`;
          }
          if (conversation?.contact) {
            title =
              title +
              ` | ${conversation?.contact?.first_name || ""} ${
                conversation?.contact?.middle_name || ""
              } ${conversation?.contact?.last_name || ""} `;
          }
          return (
            <Col sm={{ size: 12, offset: 0 }} key={index}>
              <div style={styles.conversationView}>
                <div>
                  <p>{title}</p>
                </div>
                <div>
                  <h6>Nội dung: {conversation.message}</h6>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
      {isShowModal && (
        <SiteConversationModal
          {...{ siteId, isShowModal, setIsShowModal, setConversations }}
        />
      )}
    </div>
  );
}

const styles = {
  conversationView: {
    borderRadius: 6,
    padding: 10,
    borderWidth: 1,
    borderColor: "var(--color-accent-dark)",
    marginBottom: 10,
    borderStyle: "solid",
  },
};
